import axios from "axios";

export default axios.create({
  baseURL: `https://yz1gisiwnk.execute-api.eu-central-1.amazonaws.com/prod/saveUserAnswer`,
});
